export const applicationTabs = [
  {
    id: 'my-plan',
    title: 'My Plan',
    icon: 'mdi:credit-card-settings-outline',
    permission: 'authenticated'
  },
  {
    id: 'categories',
    title: 'Categories',
    icon: 'material-symbols:category-outline',
    permission: 'content'
  },
  {
    id: 'venue-verification',
    title: 'Venue Verification',
    icon: 'mdi:store-check',
    permission: 'venues'
  },
  {
    id: 'subscriptions',
    title: 'Subscriptions',
    icon: 'mdi:cash-multiple',
    permission: 'finance'
  },
  {
    id: 'user-management',
    title: 'User Management',
    icon: 'mdi:account-group',
    permission: 'users'
  },
  {
    id: 'moderation',
    title: 'Feedback',
    icon: 'mdi:shield-alert',
    permission: 'content'
  },

  {
    id: 'positions',
    title: 'RBAC',
    icon: 'mdi:badge-account-horizontal',
    permission: 'positions'
  },
  {
    id: 'employees',
    title: 'Employees',
    icon: 'mdi:account-tie',
    permission: 'employees'
  }
];
